

import { RouteComponentProps } from 'react-router-dom';
import { IRouteLaunchArguments } from '../../controllers/launch/interface';
import { IRouteLaunch } from './interface';
import { IQueryURL } from '../../interface/util';
import { IConfigAPI } from '../../interface/config';
import { IStateUserSession } from '../../interface/state';


export function mapRouteToProps(props: RouteComponentProps<{}>, query: IQueryURL, state: IStateUserSession, config: IConfigAPI): IRouteLaunchArguments {
    const args: Partial<IRouteLaunch> = query.parse(props.location.search) ?? {};

    const route: IRouteLaunchArguments = {
        db: args?.db || state.sessionName || config.auth.username,
        sessionName: args?.sessionName || state.sessionName || config.auth.username,
    }

    return route;
}

export function mapPropsToUserState(props: IRouteLaunchArguments, defaultValues: IStateUserSession): IStateUserSession {
    return {
        ...defaultValues,
        sessionName: props.sessionName,
    }
}

export function equals(args1: IRouteLaunchArguments, args2: IRouteLaunchArguments): boolean {
    if ( args1.db === args2.db ) { return true; }
    if ( args1.sessionName === args2.sessionName ) { return true; }
    return false;
}
